import {
  Component,
  EventEmitter,
  HostBinding,
  HostListener,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { Router } from '@angular/router';
import { CtxMenuSezioni } from '../../../common/models/ctx-menu-sezioni';
import { DescrittoreSezione } from '../../../common/models/descrittore-sezione';
import { SearchRequest } from '../../../common/models/dto/search-request';
import { SearchResponse } from '../../../common/models/dto/search-response';
import { TipoPratica } from '../../../common/models/tipologiche/tipo-pratica';
import { FrontEndMapping, FrontEndMapping as mapFe, } from '../../../core/configuration/front-end-mapping';
import { CategoriaFaccetta } from '../../../search/faccette/categoria-faccetta';
import { Faccetta } from '../../../search/faccette/faccetta';
import { FaccettaRequest } from '../../../search/faccette/faccetta-request';
import { ServicesSearch } from '../../../search/services/search.service';
import { UrlSettingsCore } from '../../configuration/url-settings-core';
import { FilesList } from '../../models/files';
import { HelpersService } from '../../services/helpers.service';
import { ViewManagerService } from '../../services/view-manager-service';
import { DialogService } from '../dialog/dialog.service';
import { ctxMenuConfig, CtxMenuConfig } from './ctx-menu-config';
import {NomiDescrittoriSezione} from "../../../common/configuration/nomi-descrittori-sezione";
import { PraticaSelectionComponent } from '../pratica-selection/pratica-selection.component';
import { ResponsiveService } from '../../services/responsive.service';
import { Breakpoints } from '@angular/cdk/layout';
import { AppData } from 'src/app/data-store';
import { ConfigurationService } from 'src/app/common/configuration/services/configuration.service';
import { PdaAuthService } from 'src/app/pda/utils/Service/pda-auth.service';
import { ConfigurationFeature } from 'src/app/common/configuration/models/configuration';

declare var diffToArrayFaccette: any;

@Component({
  selector: 'nav [ctxMenu]',
  templateUrl: 'ctx-menu.component.html',
  host: { '[attr.id]': "'sidebarsx'", '[class.dropdown]': "'true'" },
  styleUrls: ['ctx-menu.component.css']
})
export class CtxMenuComponent implements OnInit, OnDestroy, OnChanges {
  readonly mapFe = mapFe;
  urladdPratica: string = '/' + UrlSettingsCore.URL_MODULO_PRATICA_CREATE;
  private numFaccetteSelezionate: number = 0;
  private globalMenuFaccette: CategoriaFaccetta[];
  private faccetteSelezionate: any = {};
  private faccetteDaApplicare: any = {};
  private ultimaCategoriaSelezionata: string;
  private tipiPraticaOptions: TipoPratica[] = [];
  private faccetteInvariate: any = [];
  isTabletSizeScreen = false;
  sezioni: boolean;
  // menuSezioni: CtxMenuSezioni;
  @Input() menuSezioni: CtxMenuSezioni;
  // subscription: Subscription;
  faccettaRequest: FaccettaRequest;
  indexPrimaCategoriaFaccette: number = 0;
  public menuOptions: CtxMenuConfig[] = []; // menu options configuration
  dataToggle: string;
  pdaLogout;
  pdaLogin;
  @Output()
  onMenuClickEvent = new EventEmitter();

  @Output()
  onUpdateMenu = new EventEmitter();

  @HostBinding('class.open')
  isOpen: boolean;



  @HostListener('change', ['$event'])
  async updateMenuSezioni(menuSezioni: CtxMenuSezioni) {
    this.onUpdateMenu.emit();
    if (menuSezioni instanceof CtxMenuSezioni) {
      this.menuSezioni = menuSezioni;
      
      if (!menuSezioni.upperList || menuSezioni.upperList.length > 0) {
        // this.isOpen = false;
        this.dataToggle = 'dropdown';
      }
      if (menuSezioni.upperList && menuSezioni.upperList.length === 0) {
        // this.isOpen = true;
        this.dataToggle = '';
      }
      this.checkPdaConnection();
  
    }
  }

  private checkPdaConnection() {
    this.pdaLogin = this.pdaAuth.isLogged.subscribe(async (login) => {
      this.menuSezioni = this.hideEventiCancelleria(this.menuSezioni, login);
    });
  }

  get dynamicInjection() {
    return this.viewManagerService.dynamicInjectComponent(NomiDescrittoriSezione.DESCRITTORE_CANCELLERIA_TELEMATICA);
  }

  constructor(
    private viewManagerService: ViewManagerService,
    public router: Router,
    private helpers: HelpersService,
    private services: ServicesSearch,
    public frontEndMapping: FrontEndMapping,
    private dialog: DialogService,
    private responsive: ResponsiveService,
    private configService : ConfigurationService,
    private pdaAuth : PdaAuthService,

  ) {
    this.sezioni = true;
    this.configService.config.subscribe(() => {
      this.setMenuByConfig();
    })
  }

  ngOnInit() {
    this.setMenuByConfig();
    this.viewManagerService.ctxMenuFaccette.subscribe((res) =>
      this.disegnaMenuFaccette(res)
    );
    if(!!AppData.getInstance().temporaryFaccette) {
      this.disegnaMenuFaccette(AppData.getInstance().temporaryFaccette)
    }
    if(!AppData.getInstance().descrittori) {
      this.helpers.getDescrittori().subscribe((res) => {
        AppData.getInstance().descrittori = res;
        this._setDescrittoriMenu(res, this.menuOptions);
        this.viewManagerService.cacheDescriptors(res);
      });
    } else {
        this._setDescrittoriMenu(
          AppData.getInstance().descrittori, 
          this.menuOptions
        );
        this.viewManagerService.cacheDescriptors(
          AppData.getInstance().descrittori
        );
    }
    // if(!AppData.getInstance().descrittori) {
    // } else {
    //   this._setDescrittoriMenu(AppData.getInstance().descrittori, this.menuOptions);
    //   this.viewManagerService.cacheDescriptors(AppData.getInstance().descrittori);
    // }
    this.faccetteSelezionate = [];
    if (!AppData.getInstance().tipiPratica) {
      this.helpers
        .getTipiPratica()
        .subscribe((response) => {
          this.tipiPraticaOptions = response
          AppData.getInstance().tipiPratica = response;
        });
    } else {
      this.tipiPraticaOptions = AppData.getInstance().tipiPratica;
    }
    this.responsive.checkScreenSizeDynamic([
      Breakpoints.XSmall,
      Breakpoints.Small,
      Breakpoints.Medium
    ]).subscribe(
      state => this.isTabletSizeScreen =  state.matches
    )
  }

  isDropdown():boolean {
    let result = (this.menuSezioni.upperList && this.menuSezioni.upperList.length > 0) ||
    (this.menuSezioni.inserimento && this.menuSezioni.secondoStadioInserimento && this.menuSezioni.lowerList.length > 0) ||
    (this.faccettaRequest && this.faccettaRequest.faccetteApplicabili && this.faccettaRequest.faccetteApplicabili.length > 0) ? true : false;
    return result;
  }

  setMenuByConfig(){
    this.menuOptions = [];
    const menu = ctxMenuConfig;
    // console.log(menu , 'ctxMenuConfig')
    menu.forEach(element => {
      if(element.feature){
        const isEnable = this.configService.isFeatureEnabled(element.feature);
        if(isEnable){
          this.menuOptions.push(element)
        }
      } else {
        this.menuOptions.push(element)
      }
    });
  }

  faccetteX(keyName, valore) {
    let faccetta = this.faccetteInvariate.filter(
      (faccetta) => faccetta.keyName === keyName
    )[0];
    let val = faccetta.values.filter((value) => value.valore === valore)[0];
    return val ? val.numOccorrenze : '0';
  }

  onFilesListCollect(files: FilesList[]) {
    if(files.length < 1) return
    if(this.router.url !== "/welcome-board") this.router.navigate(["/welcome-board"])
  }

  disegnaMenuFaccette(faccettaRequest: FaccettaRequest) {
    // menuFaccetteApplicabili: FaccetteApplicabili)
    if (!this.globalMenuFaccette) {
      this.services
        .searchFaccetteGlobali()
        .subscribe((res) => this.setFaccetteGlobali(res));
    }
    this.faccettaRequest = faccettaRequest;
    this.faccetteDaApplicare = [];
    this.faccetteInvariate = faccettaRequest.faccetteApplicabili;
    if (
      faccettaRequest &&
      faccettaRequest.faccetteApplicabili &&
      faccettaRequest.faccetteApplicabili.length > 0
    ) {
      // this.isOpen = false;
      this.dataToggle = 'dropdown';
      this.indexPrimaCategoriaFaccette = this.getPrimaCategoriaCollapsed(this.faccettaRequest.faccetteApplicabili);
    } else {
      // this.isOpen = true;
      this.dataToggle = '';
    }
    //this.faccetteDaApplicare = undefined;
  }

  private _setDescrittoriMenu(desc: DescrittoreSezione[], menu: CtxMenuConfig[]) {
    menu.forEach(menuItem => {
      menuItem.disabled = true;
      // Verifico se l'elemento ha un descrittore
      if (menuItem.descriptor) {
        // Se `descriptor` è un array, abilito se almeno uno degli `entitySimpleName` associati è `writable`
        if (Array.isArray(menuItem.descriptor)) {
          menuItem.disabled = !desc.some(el => 
            menuItem.descriptor.includes(el.entitySimpleName) && el.writable
          );
        } else {
          menuItem.disabled = !desc.some(el => 
            menuItem.descriptor === el.entitySimpleName && el.writable
          );
        }
      } else {
        // Per gli elementi senza descrittore
        menuItem.disabled = false;
      }
    });

    // Aggiorna `menuOptions` dopo le modifiche
    this.menuOptions = menu;
  } 
  

  ngOnChanges(changes: SimpleChanges) {
    if (changes.menuSezioni && changes.menuSezioni.currentValue) {
      this.updateMenuSezioni(this.menuSezioni);
    }
  }

  setFaccetteGlobali(response: SearchResponse) {
    this.globalMenuFaccette = response.faccetteApplicabili;
  }


  ngOnDestroy() {
    // this.subscription.unsubscribe();
    //this.subscriptionFaccette.unsubscribe();
    // this.pdaLogout.unsubscribe();
  }

  refreshRisultatiPratica(response: SearchResponse) {
    if (response.pratiche.length != 0) {
      this.viewManagerService.reloadRisultatiRicercaPratiche(response);
      this.menuSezioni = new CtxMenuSezioni();
      this.menuSezioni.showMenu = true;
      this.menuSezioni.inserimento = false;
      this.menuSezioni.secondoStadioInserimento = false;
      this.menuSezioni.lowerList = [];
      this.menuSezioni.upperList = [];

      this.reloadMenuFaccette(response.faccetteApplicabili);
    } else {
      response.faccetteApplicabili = this.globalMenuFaccette;
      this.reloadMenuFaccette(this.globalMenuFaccette);
    }
  }

  reloadMenuFaccette(faccetteApplicabili: CategoriaFaccetta[]) {
    let categorieFaccetteIniziali: CategoriaFaccetta[] = JSON.parse(
      JSON.stringify(this.faccetteInvariate)
    );
    let categorieFaccetteRicalcolate: CategoriaFaccetta[] = faccetteApplicabili;
    //let categorieFaccetteRicalcolate: CategoriaFaccetta[] = faccetteTestResponsepost;
    let categorieFaccetteDaMostrare: CategoriaFaccetta[] = [];

    /*
      E' necessario ricaricare le faccette:
      il backend torna soltanto le faccette con numero di occorrenze > 0
      E' necessario mostrare a video anche le faccette con numero occorrenze = 0,
      quindi metto in cahche la le faccette totali e le mergio con le faccette ricalcolate dopo la ricerca
      così da ottenere nel nuovo menu tutte le faccette(sia con che senza occorrenze)
    */

    categorieFaccetteIniziali.forEach((categoriaIniziale, index) => {
      let temp: CategoriaFaccetta[] = categorieFaccetteRicalcolate.filter(
        (categoriaRicalcolataFilter) =>
          categoriaRicalcolataFilter.keyName === categoriaIniziale.keyName
      );
      let categoriaRicalcolata: CategoriaFaccetta =
        temp && temp.length > 0 ? temp[0] : undefined;

      if (categoriaRicalcolata) {
        let faccetteDaMostrare: Faccetta[] = [];

        let faccetteTemp: Faccetta[] = [];

        let faccetteIniziali: Faccetta[] = categoriaIniziale.values;

        let faccetteRicalcolate: Faccetta[] = categoriaRicalcolata.values
          ? categoriaRicalcolata.values
          : [];

        /*Faccio la differenza tra i due array, l'array risultante è composto dagli elementi che non tornano dal back-end
          ovvero quelli con occorrenze = 0
        */
        let faccetteNonRicalcolate: Faccetta[] = faccetteIniziali.filter(
          diffToArrayFaccette(faccetteRicalcolate)
        );

        if (faccetteNonRicalcolate) {
          faccetteNonRicalcolate.forEach((element) => {
            if (categoriaIniziale.keyName != this.ultimaCategoriaSelezionata) {
              element.numOccorrenze = 0;
            } else if (
              categoriaIniziale.values != categoriaRicalcolata.values
            ) {
              element.numOccorrenze = 0;
            }
          });
          faccetteTemp = faccetteRicalcolate.concat(faccetteNonRicalcolate);
          faccetteDaMostrare = faccetteTemp.sort(
            (a, b) => b.numOccorrenze - a.numOccorrenze
          );
        } else {
          faccetteDaMostrare = faccetteRicalcolate;
        }

        categoriaIniziale.values = faccetteDaMostrare;
        categorieFaccetteDaMostrare[index] = categoriaIniziale;
      } else {
        categoriaIniziale.values.forEach((element) => {
          element.numOccorrenze = 0;
        });
        categorieFaccetteDaMostrare[index] = categoriaIniziale;
      }
    });

    this.faccettaRequest.faccetteApplicabili = categorieFaccetteDaMostrare;
    this.indexPrimaCategoriaFaccette = this.getPrimaCategoriaCollapsed(categorieFaccetteDaMostrare);
    this.globalMenuFaccette = this.faccettaRequest.faccetteApplicabili;
    window.scrollTo(0, 0);
  }

  isFaccettaSelezionata(valoreFaccetta: string, keynameCategoria: string): boolean {
    this.faccetteDaApplicare = AppData.getInstance().faccetteDaApplicare;
    if (this.faccetteDaApplicare[keynameCategoria])
      return this.faccetteDaApplicare[keynameCategoria].indexOf(valoreFaccetta) > -1;
    return false;
  }

  applicaFaccetta(
    categoriaSel: CategoriaFaccetta,
    valoreSelezionato: Faccetta,
    event: any
  ) {
    AppData.getInstance().faccetteDaApplicare = [];
    let request: SearchRequest = new SearchRequest();
    this.ultimaCategoriaSelezionata = categoriaSel.keyName;
    request.includePratiche =  this.faccettaRequest.includePratiche;
    request.includeFascicoli =  !this.faccettaRequest.includePratiche;
    request.includiFaccette = true;
    request.searchCriteria = this.faccettaRequest.searchRequest;
    let appData = AppData.getInstance();
    if (appData.searchAsc !== null) {
      request.asc = AppData.getInstance().searchAsc;
    } else {
      request.asc = false;
    }
    if (appData.searchNomeCampoOrdinamento !== null) {
      request.nomeCampoOrdinamento = AppData.getInstance().searchNomeCampoOrdinamento;
    } else {
      request.nomeCampoOrdinamento = 'posizioneOrd.keyword'
    }
    request.fromResult = 0;
    if (this.faccetteDaApplicare[categoriaSel.keyName]) {
      let index = this.faccetteDaApplicare[categoriaSel.keyName].indexOf(
        valoreSelezionato.valore
      );
      if (index > -1) {
        this.faccetteDaApplicare[categoriaSel.keyName].splice(index, 1);
        if (!this.faccetteDaApplicare[categoriaSel.keyName].length)
          delete this.faccetteDaApplicare[categoriaSel.keyName];
      } else {
        this.faccetteDaApplicare[categoriaSel.keyName].push(
          valoreSelezionato.valore
        );
      }
    } else {
      this.faccetteDaApplicare[categoriaSel.keyName] = [
        valoreSelezionato.valore,
      ];
    }

    Object.keys(this.faccetteDaApplicare).forEach((key) => {
      request.faccetteDaApplicare[key] = this.faccetteDaApplicare[key].join(
        ','
      );
    });
    AppData.getInstance().faccetteDaApplicare = this.faccetteDaApplicare;
    if(!!AppData.getInstance().nomeCampoOrdinamento) {
      request.nomeCampoOrdinamento = AppData.getInstance().nomeCampoOrdinamento;
    }
    this.services
      .search(request)
      .subscribe((response) => this.refreshRisultatiPratica(response));
  }

  hasFaccetteSelezionate(faccetta: CategoriaFaccetta): boolean {
    return !!faccetta.values.find(element => this.isFaccettaSelezionata(element.valore, faccetta.keyName));
  }

  getPrimaCategoriaCollapsed(listaCategorie: CategoriaFaccetta[]): number {
    for (let i = 0; i < listaCategorie.length; i++) {
      if (listaCategorie[i].values.length > 0) {
        return i;
      }
    }
  }

  getLabelPraticaByEndpoint(endpoint) {
    let tipoPratica = '';
    this.frontEndMapping.getListTipiPratica(endpoint).subscribe((res) => {
      tipoPratica = res;
    });
    return tipoPratica;
  }

  isDocumentManagementEnabled(): boolean {
    const index = this.menuOptions.findIndex(i => i.descriptor === NomiDescrittoriSezione.DESCRITTORE_GESTIONE_DOCUMENTI);
    return index > -1 ? true : false;
  }

  onClickMenuLink(hasModal) {
    if(hasModal) {
      this.dialog.open(PraticaSelectionComponent, {
        data: {
          tipiPratica: this.tipiPraticaOptions,
          style: {
            width: '60vw'
          },
          title: 'Aggiungi nuova pratica',
        }
      })
      this.onMenuClickEvent.emit()
      return
    }
    this.onMenuClickEvent.emit();
  }

  hideEventiCancelleria(menuSezioni: any, loginState){;
    let index = menuSezioni.upperList.findIndex(x => x.id === "eventicancelleria_fascicolo");
    if(!loginState){
      if(index > -1) {
        menuSezioni.upperList[index].disabled = true;
      }
    } else {
      if(index > -1) {
        menuSezioni.upperList[index].disabled = false;
      }
    }
    return menuSezioni
  }

  onKeydown(event: KeyboardEvent, index: number): void {
    const items = Array.from(document.querySelectorAll('#navigazioneprincipale [role="menuitem"]')) as HTMLElement[];

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault();
        items[(index + 1) % items.length].focus();
        break;
      case 'ArrowUp':
        event.preventDefault();
        items[(index - 1 + items.length) % items.length].focus();
        break;
      case 'Enter':
      case ' ':
        event.preventDefault();
        (event.target as HTMLElement).click();
        break;
      case 'Escape':
        // se il menu è a discesa, chiudilo
        // if (this.isDropdown()) this.closeDropdown();
        break;
    }
  }

}


